import React from "react";
import { Grid } from "@material-ui/core";

import { bookingSystemTypeToString } from "features/planner/planner.mappers";
import ColumnDescription from "features/planner/report/helicopter/components/ColumnDescription";
import HeliReportClearRow from "features/planner/report/helicopter/components/HeliReportClearRow";

const OffshoreBoundColumnDescription = ({ bookingSystemType }) => (
  <Grid container item wrap="nowrap" alignItems="center">
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>
        {bookingSystemTypeToString(bookingSystemType)}
      </ColumnDescription>
    </Grid>
    <Grid item xs={2} zeroMinWidth>
      <ColumnDescription>Name</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Date</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>CheckIn</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Heliport</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Shift</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Service</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Return Date</ColumnDescription>
    </Grid>
    <Grid item>
      <HeliReportClearRow visible={false} />
    </Grid>
  </Grid>
);

export default OffshoreBoundColumnDescription;
